/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from "../../utils/axiosInstance"

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  saveTour: [],
  tourCityList: [],
  staycationList: undefined,
  staycationDetail: undefined,
  stayCationList: undefined,
  stayCationListNew: undefined,
  staycationBookingRes: undefined,
  staycationSearchListRes: undefined,
};

const slice = createSlice({
  name: 'staycation',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    //GET getHotelCityList
    getStaycationListSuccess(state, action) {
      state.isLoading = false;
      state.stayCationList = action.payload;
    },
    getStaycationListNewSuccess(state, action) {
      state.isLoading = false;
      state.stayCationListNew = action.payload;
    },
    getStaycationDetailSucess(state, action) {
      state.isLoading = false;
      state.staycationDetail = action.payload;
    },
    staycationSaveBookingSuccess(state, action) {
      state.isLoading = false;
      state.staycationBookingRes = action.payload;
    },
    getSearchStaycationSuccess(state, action) {
      state.isLoading = false;
      state.staycationSearchRes = action.payload;
    },
    getSearchStaycationListSuccess(state, action) {
      state.isLoading = false;
      state.staycationSearchListRes = action.payload;
    },
    getSearchStaycationFilterSuccess(state, action) {
      state.isLoading = false;
      state.staycationSearchFilterRes = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

//SAVEHOTELSBOOKINGS

export function getStaycationList(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/staycations/list`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(
        slice.actions.getStaycationListSuccess(response.data.stayCationList)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getStaycationListNew(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/staycations/list`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(
        slice.actions.getStaycationListNewSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getStaycationDetail(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/staycations/detail`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(
        slice.actions.getStaycationDetailSucess(response.data.stayCation)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function staycationSaveBooking(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/staycationBooking`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.staycationSaveBookingSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchStaycation(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/staycations/searchStaycation`,
        obj
      );
      dispatch(slice.actions.getSearchStaycationSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchStaycationList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/staycations/searchList`,
        obj
      );
      dispatch(
        slice.actions.getSearchStaycationListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchStaycationFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/staycations/filterList`,
        obj
      );
      dispatch(
        slice.actions.getSearchStaycationFilterSuccess(
          response.data?.responseData
        )
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
